import { Controller } from "@hotwired/stimulus";
import { badgeClasses } from '@/utils/badge_classes'

// Live-recompute the Credits / Debits / Count summary and the reconciliation
// (opening + credits - debits = expected closing, vs the statement closing) as
// the user edits amounts or toggles Include checkboxes, before saving.
export default class extends Controller {
  static targets = ["credits", "debits", "count", "expected", "difference", "status"];
  static values = {
    currency: { type: String, default: "USD" },
    opening: Number,
    closing: Number,
    hasBalances: Boolean
  };

  connect() {
    this.recalc();
  }

  recalc() {
    let credits = 0;
    let debits = 0;
    let count = 0;

    this.element.querySelectorAll("tbody tr[data-row]").forEach((row) => {
      const checkbox = row.querySelector('input[type="checkbox"]');
      const included = !checkbox || checkbox.checked;

      row.classList.toggle("table-light", !included);
      row.classList.toggle("text-muted", !included);
      if (!included) return;

      const amountValue = row.querySelector("[data-amount]")?.value || "";
      const amount = parseFloat(amountValue.replace(/,/g, "")) || 0;
      count += 1;
      if (amount > 0) credits += amount;
      else if (amount < 0) debits += Math.abs(amount);
    });

    this.creditsTargets.forEach((el) => (el.textContent = this.format(credits)));
    this.debitsTargets.forEach((el) => (el.textContent = this.format(debits)));
    this.countTargets.forEach((el) => (el.textContent = count));

    if (this.hasBalancesValue) {
      const expected = this.openingValue + credits - debits;
      const diff = expected - this.closingValue;
      const balanced = Math.abs(diff) < 0.005;

      this.expectedTargets.forEach((el) => (el.textContent = this.format(expected)));
      this.differenceTargets.forEach((el) => {
        el.textContent = this.format(diff);
        el.classList.toggle("text-success", balanced);
        el.classList.toggle("text-danger", !balanced);
      });
      this.statusTargets.forEach((el) => {
        el.textContent = balanced ? "Balanced" : `Off by ${this.format(Math.abs(diff))}`;
        el.className = badgeClasses({ variant: balanced ? 'success' : 'danger', subtle: true, outline: true });
      });
    }
  }

  format(value) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: this.currencyValue || "USD"
    }).format(value);
  }
}
